// This file is the main entry point for the theme. It is used to import all the global files for the theme to work.
import 'vite/modulepreload-polyfill'

// Mini Cart - Vanilla JS Web Component (no Vue)
import MiniCart from "@/js/components/mini-cart";

// Register Mini Cart Web Component
if (!customElements.get('mini-cart-component')) {
  customElements.define('mini-cart-component', MiniCart);
}

// Helpers, local to our custom theme.
import "@/js/helpers/video-plays-in-view";
import "@/js/helpers/collection-filter";
import "@/js/helpers/variant-form-handler";
import "@/js/helpers/recently-viewed-tracker";
import "@/js/helpers/fly-out-panel-toggle";
import toggleBodyClass from "@/js/helpers/toggle-body-class";
import { loadComponentIfNeeded } from "@/js/helpers/load-component-if-needed";

// Import RecentlyViewed to expose globally
import { RecentlyViewed } from "@theme/recently-viewed-products";

// Import directly from Horizon theme /asstes/ folder.
import "@theme/dialog";
import "@theme/predictive-search";
import "@theme/facets";
import "@theme/localization";
import "@theme/quick-add";


// Components, local to our custom theme - Load dynamically to reduce initial bundle
import PDPAddToCartButton from "../js/components/pdp-add-to-cart-button";
import QuantitySelector from "@/js/components/quantity-selector";
import MegaMenu from "@/js/components/mega-menu";
import FooterAccordion from "@/js/components/footer-accordion";
import UniversalAccordion from "@/js/components/universal-accordion";
import TabbedPanels from "@/js/components/tabbed-panels";
import VariantPicker from "@theme/variant-picker";
import plpCard from "@/js/components/plp-card";
import "@/js/components/quick-view";
import "@/js/components/price-range-slider";
import "@/js/components/banner-scene";
import "@/js/components/ajax-filter-handler";
import CustomSlideshow from "@/js/components/custom-slideshow.js";
if (!customElements.get("plp-card")) {
  customElements.define("plp-card", plpCard); 
}


// Define critical Web Components immediately
customElements.define("quantity-input", QuantitySelector);
customElements.define("mega-menu", MegaMenu);
customElements.define("footer-accordion", FooterAccordion);
customElements.define("universal-accordion", UniversalAccordion);
if (!customElements.get("tabbed-panels")) {
  customElements.define("tabbed-panels", TabbedPanels);
}
if (!customElements.get("variant-picker")) {
  customElements.define("variant-picker", VariantPicker);
}
if (!customElements.get("pdp-add-to-cart-button")) {
  customElements.define("pdp-add-to-cart-button", PDPAddToCartButton);
}
if (!customElements.get('slideshow-component')) {
  customElements.define('slideshow-component', CustomSlideshow);
}
// Load components only when their elements exist on the page
loadComponentIfNeeded("klaviyo-form", "klaviyo-form", () => import("@/js/components/klaviyo-form"));
loadComponentIfNeeded("swiper-component", "swiper-component", () => import("@/js/components/swiper"));
loadComponentIfNeeded("ajax-pagination", "ajax-pagination", () => import("@/js/components/ajax-pagination"));
loadComponentIfNeeded("load-more-products", "load-more-products", () => import("@/js/components/load-more-products"));
loadComponentIfNeeded("ticker-tape", "ticker-tape", () => import("@/js/components/ticker-tape"));
loadComponentIfNeeded("fbt-block", "fbt-block", () => import("@/js/components/fbt-block"));
loadComponentIfNeeded(".video-product-carousel-section", "video-product-carousel-section", () => import("@/js/components/reel-section"));


// Expose helper functions globally
declare global {
  interface Window {
    toggleBodyClass: typeof toggleBodyClass;
    RecentlyViewed: typeof RecentlyViewed;
  }
}

window.toggleBodyClass = toggleBodyClass;
window.RecentlyViewed = RecentlyViewed;


// horizon web components
// TODO Could register them all through on entry point file like this?
// import { inithorizonComponents } from "@theme/js/components/init";
// window.customElements.define("dialog-component", DialogComponent);
// window.customElements.define('predictive-search-component', PredictiveSearchComponent);
// window.customElements.define('declarative-shadow-element', DeclarativeShadowElement);

